import { Component } from '@angular/core';

@Component({
  selector: 'app-daily-delivery-order',
  standalone: false,
  
  templateUrl: './daily-delivery-order.component.html',
  styles: ``
})
export class DailyDeliveryOrderComponent {

}
